import * as React from 'preact/compat'
import BackButton from '../BackButton'
import type { DialogComponentPropTypes } from '../AuthDialog'
import styles from '../../../../css/auth.pcss.json'

const PageRegisterSuccess: React.FunctionComponent<DialogComponentPropTypes> = ({ switchPage }) => {

  const toLogin = () => switchPage('login')

  return <>
    <BackButton goBack={toLogin} />
    <div className={styles['auth-header']}>
      <h1 style='color: var(--green)'>Спасибо!</h1>
    </div>
    <p style="text-align: center">На твой email отправлено письмо<br/>со ссылкой для активации аккаунта<br/>и данными для входа.</p>
    <p style="text-align: center; color: var(--gray-2);">Если не активировать аккаунт<br/>в течение 24 часов, то он будет удалён.</p>
    <p style="text-align: center; color: var(--gray-2);">Можешь закрыть это окно и проверить почту.</p>
  </>
}

export default PageRegisterSuccess
